import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'
Vue.use(Vuex)
 
export default new Vuex.Store({
  state:{
    count:0,
    d1:0,
    d2:false,
    d3:false,
    d4: '', // 控制首页滚动的时候导航栏没有背景颜色
    d5:false,
    d6:'',
    homeDot: false, // 导航栏的点
    hardDot: false,
    softDot: false,
    coopDot: false,
    aboutDot: false,
  },
  mutations:{
    increment:state => state.count ++,
    decrement:state => state.count --,
  }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js